import React from "react";
interface props {
  className?: string;
  fill?: string;
}
function LinkedinSvg({ className, fill }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      className={className}
      fill="none"
      viewBox="0 0 21 20"
    >
      <path
        fill={fill ? fill : "#fff"}
        d="M1.883 2.21v16.575h16.574V2.211H1.883zm4.064 3.26c.657.007 1.304.46 1.332 1.244.014.697-.594 1.228-1.349 1.244h-.018c-.65-.008-1.285-.472-1.314-1.244.01-.69.589-1.228 1.35-1.245zm7.043 3.293c.722.005 1.403.219 1.963.79.581.648.768 1.542.789 2.451v4.136h-2.384v-3.854c-.005-.723-.252-1.601-1.208-1.63-.56.006-.956.331-1.226.876-.074.175-.085.377-.088.578v4.03H8.453c.01-2.015.022-4.03.017-6.045 0-.572-.005-.957-.017-1.156h2.383v1.016c.202-.288.426-.56.727-.78.408-.291.898-.403 1.427-.412zM4.74 8.94H7.12v7.2H4.739v-7.2z"
        opacity="0.8"
      ></path>
    </svg>
  );
}

export default LinkedinSvg;
